import React, { useRef, useState } from 'react';
import { SubscribeForm } from '../components/whatsnew/SubscribeForm';
import { FilterChips } from '../components/whatsnew/FilterChips';
import { FeaturedArticle } from '../components/articles/FeaturedArticle';
import { ArticleCard } from '../components/articles/ArticleCard';
import { NewsletterCard } from '../components/articles/NewsletterCard';
import { Pagination } from '../components/articles/Pagination';
import { CtaBand } from '../components/company/CtaBand';
import { articleCategories, articles } from '../data/articles/posts';
import type { ArticleCategory } from '../types/article';
const PAGE_SIZE = 9;
export function Blog() {
  const [category, setCategory] = useState<'All' | ArticleCategory>('All');
  const [page, setPage] = useState(1);
  const gridRef = useRef<HTMLElement>(null);
  const featured = articles[0];
  const list = category === 'All' ? articles.slice(1) : articles.filter(a => a.category === category);
  const pageCount = Math.max(1, Math.ceil(list.length / PAGE_SIZE));
  const shown = list.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const goToPage = (p: number) => {
    setPage(p);
    gridRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <main data-id="element-1741" data-mp="2bvp1u723v2ew">
      <section className="hero-surface w-full" aria-labelledby="blog-heading" data-id="element-1742" data-mp="2bvys7vr2bbl4">
        <div className="mx-auto max-w-shell px-6 pb-16 pt-14 lg:pb-20 lg:pt-20" data-id="element-1743" data-mp="2fvh647kgumeg">
          <div className="max-w-[720px]" data-id="element-1744" data-mp="1j7ji9nmsfjgn">
            <h1 id="blog-heading" className="display text-[40px] font-semibold text-ink sm:text-[52px] lg:text-[60px]" data-id="element-1745" data-mp="1j8kvnyra0i1j">
              The Kayko Blog
            </h1>
            <p className="mt-5 max-w-[560px] text-[18px] leading-[1.5] text-ink-soft" data-id="element-1746" data-mp="1s6eov0tquvkh">
              Practical tips to help your business sell more, spend less, and grow.
            </p>
            <SubscribeForm id="blog-hero-email" buttonLabel="Subscribe" successText="You’re subscribed. Look out for our next tip." align="left" className="mt-8" data-id="element-1747" data-mp="33lbeocxr5osw" />
          </div>
          <div className="mt-12" data-id="element-1748" data-mp="14hlexctp50yy">
            <FeaturedArticle article={featured} data-id="element-1749" data-mp="14id1jy5bfod3" />
          </div>
        </div>
      </section>

      <section ref={gridRef} className="w-full scroll-mt-[96px] bg-white py-16 lg:py-20" aria-labelledby="latest-heading" data-id="element-1750" data-mp="1ihme8nubc0cb">
        <div className="mx-auto max-w-shell px-6" data-id="element-1751" data-mp="1djkt7xdbtqy7">
          <h2 id="latest-heading" className="display text-[30px] font-semibold text-ink sm:text-[40px]" data-id="element-1752" data-mp="psfhnuef5ktp">
            Latest articles
          </h2>
          <div className="mt-8 md:[&>div]:justify-start" data-id="element-1753" data-mp="kv6x5n5st4pa">
            <FilterChips options={articleCategories} value={category} onChange={v => {
            setCategory(v);
            setPage(1);
          }} ariaLabel="Filter articles by category" data-id="element-1754" data-mp="zj0cr7uvw77v" />
          </div>

          {shown.length > 0 ? <ul className="mt-10 grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-2 lg:grid-cols-3" data-id="element-1755" data-mp="2232byguglt3">
              {shown.map((article, i) => <React.Fragment key={article.slug} data-id="element-1756" data-mp="2domzjjkg6a24" data-mpi={i}>
                  <li data-id="element-1757" data-mp="2ii7zhh5lpe3y">
                    <ArticleCard article={article} data-id="element-1758" data-mp="2iihgif8o4axi" />
                  </li>
                  {i === 5 && shown.length > 6 && <li className="md:col-span-2 lg:col-span-3" data-id="element-1759" data-mp="28rd1xgmwms37">
                      <NewsletterCard id="blog-inline-email" data-id="element-1760" data-mp="28rwiaswwp8f4" />
                    </li>}
                </React.Fragment>)}
            </ul> : <div className="mx-auto mt-10 max-w-[480px] rounded-[14px] border border-canvas-line px-6 py-10 text-center" data-id="element-1761" data-mp="31er4pvdaahv8">
              <p className="text-[16px] font-semibold text-ink" data-id="element-1762" data-mp="2nfzp24irwo4z">No articles in this category yet</p>
              <button type="button" onClick={() => setCategory('All')} className="mt-4 text-[15px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-1763" data-mp="2sdj8rjy8pt4b">
                Show all articles
              </button>
            </div>}

          {shown.length > 0 && shown.length <= 6 && <div className="mt-14" data-id="element-1764" data-mp="1rhszg3syvksd">
              <NewsletterCard id="blog-inline-email" data-id="element-1765" data-mp="1mjretefw7des" />
            </div>}

          <Pagination page={page} pageCount={pageCount} onChange={goToPage} data-id="element-1766" data-mp="1mhodhy9ahxur" />
        </div>
      </section>

      <CtaBand headline="Put these tips to work with Kayko" subheadline="Sales, stock, expenses, and reports in one place. Set up in minutes." primary={{
      label: 'Get started',
      href: '/get-started'
    }} secondary={{
      label: 'Book a demo',
      href: '/demo'
    }} data-id="element-1767" data-mp="2f8pxccnxghkm" />
    </main>;
}